import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { opacityToAlpha, alphaToOpacity } from '@framework/workbench/drawer/utils';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import { IPictureOpacityFeature } from './picture-opacity-interface';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';

const defaultPictureEditProps = {
    alpha: 1,
};

@Feature()
export class PictureOpacityFeature extends BaseDrawerFeature implements IPictureOpacityFeature {
    public pictureEditProps = { ...defaultPictureEditProps };
    public get pictureEditInfo() {
        const pictureColor = this.getPropertyMenu()?.values?.[ActionType.INSERT_PICTURE];
        return pictureColor ? pictureColor : defaultPictureEditProps;
    }
    public get opacity(): number {
        return alphaToOpacity(this.pictureEditProps?.alpha);
    }

    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.PICTURE_OPACITY);
    }

    public initPropsCallback = () => {
        this.pictureEditProps = { ...this.pictureEditInfo };
    };

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.PICTURE_OPACITY)
    public changeOpacity(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const alpha = opacityToAlpha(value);
        this.pictureEditProps = { ...this.pictureEditInfo, alpha };
        const isOnlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateProps(
            ActionType.INSERT_PICTURE, { image: { alpha } }, isOnlyChangeUI, false,
            { reportId: FormItemName.PICTURE_OPACITY },
        );
    }
}
